import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {getPlaces, getSelectedPlace, getPlacesInBasket} from '../../../../selectors/seating/places'
import {isInAccessibilityMode} from '../../../../selectors/seating/mode'
import {PlanOwnProps, PlanRuntimeProps} from './interfaces'
import {Plan as Presentation} from './plan'

const mapRuntime = ({
  state: {
    seating: {plan},
  },
  state,
  actions: {seatingMapButtonClick},
}: DetailsPageAppProps): PlanRuntimeProps => ({
  plan,
  selectedPlace: getSelectedPlace(state),
  placesInBasket: getPlacesInBasket(state),
  placesWithTicketInfo: getPlaces(state),
  showAccessibilityMode: isInAccessibilityMode(state),
  seatingMapButtonClick,
})

export const Plan = connect<PlanOwnProps, PlanRuntimeProps>(mapRuntime)(Presentation)
